export default function CTASection() {
  return (
    <section id="cta" className="w-full">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[400px] md:min-h-[480px]">
        {/* Left - Image */}
        <div className="relative h-64 lg:h-auto overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dynamic%20lifestyle%20shot%20of%20a%20happy%20person%20holding%20a%20smartphone%20with%20one%20hand%20and%20a%20shopping%20bag%20with%20the%20other%20against%20a%20bright%20city%20street%20background%2C%20confident%20smile%2C%20golden%20hour%20sunset%20lighting%2C%20urban%20fashion%20aesthetic%2C%20aspirational%20success%20vibe%2C%20warm%20atmospheric%20tones&width=900&height=600&seq=cta-left-v3&orientation=landscape"
            alt="VigorBuy Sheet - Start shopping smarter today"
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-foreground-950/40 flex items-end p-8 md:p-12">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
              Get<br />VigorBuy<br />Sheet
            </h2>
          </div>
        </div>

        {/* Right - CTA */}
        <div className="flex flex-col items-center justify-center bg-background-50 py-12 md:py-16 px-6 md:px-16 text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Ready to<br />Start Shopping?
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-sm leading-relaxed">
            Access the latest VigorBuy spreadsheet today and join 10,000+ smart shoppers who find the best products at the best prices.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 w-full max-w-sm">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full px-8 py-3.5 bg-primary-500 text-background-50 font-bold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 text-center whitespace-nowrap cursor-pointer shadow-md flex items-center justify-center gap-2"
            >
              Buy It Now
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full px-8 py-3.5 border-2 border-accent-400 text-accent-600 font-bold text-sm rounded-full hover:bg-accent-50 transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
            >
              VigorBuy Sheet
            </a>
          </div>
          <p className="mt-6 text-xs text-foreground-400">Updated Today &bull; Free Access &bull; No Registration</p>
        </div>
      </div>
    </section>
  );
}